import {
	TransferFundOptions,
	NewBeneficiary,
	TransferFunds,
	SavedBeneficiary,
	TransferPinConfirm,
} from './Transfer';
import TransferSuccess from './TransferSuccess';
import TransferFailed from './TransferFailed';
import Withdraw from './Withdraw';
import Wallet from './Wallet';
import WalletExchange from './WalletExchange';
import AccountStatement from './AccountStatement';
import BankAccountReq from './BankAccountReq';

export {
	Wallet,
	Withdraw,
	TransferSuccess,
	TransferFailed,
	TransferPinConfirm,
	TransferFundOptions,
	TransferFunds,
	SavedBeneficiary,
	NewBeneficiary,
	WalletExchange,
	AccountStatement,
	BankAccountReq,
};
